//https://reactnavigation.org/docs/configuring-links/#passing-params
//important links: https://reactnavigation.org/blog/2020/05/16/web-support/

import { createNativeStackNavigator } from "@react-navigation/native-stack";
import React from "react";
import { View, StyleSheet } from "react-native";
import NoFoundController from "../common/controllers/NoFoundController";
import routes from "./routes";
import AuthController from "../auth/controllers/AuthController";
import PasswordRecoveryController from "../auth/controllers/PasswordRecoveryController";
import OnboardingController from "../onboarding/controllers/OnboardingController";
import MarketingController from "../marketing/controllers/MarketingController";
import GuestAppController from "../marketing/controllers/GuestAppController";
import CrewAppController from "../marketing/controllers/CrewAppController";
import HospitalityController from "../marketing/controllers/HospitalityController";
import TelehealthController from "../marketing/controllers/TelehealthController";
import ImpactStudyController from "../marketing/controllers/ImpactStudyController";
import ImpactStudiesController from "../marketing/controllers/ImpactStudiesController";
import AboutUsController from "../marketing/controllers/AboutUsController";
import LearnMoreController from "../marketing/controllers/LearnMoreController";

const Stack = createNativeStackNavigator();

function AuthNavigator({ onControllerChanged, initialRoute }) {
  return (
    <Stack.Navigator
      initialRouteName={initialRoute}
      screenListeners={{
        state: (e) => {
          const controller =
            e.data.state.routes[e.data.state.routes.length - 1].name;
          if (onControllerChanged) {
            onControllerChanged(controller);
          }
        },
      }}
      screenOptions={{ headerShown: false }}
    >
      <Stack.Screen
        name={routes.marketing}
        component={MarketingController}
        options={{ title: "VOXCRAFT | Marketing" }}
      />

      <Stack.Screen
        name={routes.health}
        component={TelehealthController}
        options={{ title: "VOXCRAFT | Health" }}
      />

      <Stack.Screen
        name={routes.crewapp}
        component={CrewAppController}
        options={{ title: "VOXCRAFT | Crew App" }}
      />

      <Stack.Screen
        name={routes.guestapp}
        component={GuestAppController}
        options={{ title: "VOXCRAFT | Guest App" }}
      />

      <Stack.Screen
        name={routes.hospitality}
        component={HospitalityController}
        options={{ title: "VOXCRAFT | Hospitality" }}
      />

      <Stack.Screen
        name={routes.impactstudies}
        component={ImpactStudiesController}
        options={{ title: "VOXCRAFT | Impact Studies" }}
      />

      <Stack.Screen
        name={routes.impactstudy}
        component={ImpactStudyController}
        options={{ title: "VOXCRAFT | Impact Study" }}
      />

      <Stack.Screen
        name={routes.aboutus}
        component={AboutUsController}
        options={{ title: "NTCONNECT | About Us" }}
      />

      <Stack.Screen
        name={routes.learnmore}
        component={LearnMoreController}
        options={{ title: "VOXCRAFT | Learn More" }}
      />

      <Stack.Screen
        name={routes.auth}
        component={AuthController}
        options={{ title: "VOXCRAFT | Auth" }}
      />

      <Stack.Screen
        name={routes.passwordrecovery}
        component={PasswordRecoveryController}
        options={{ title: "VOXCRAFT | Reset password" }}
      />

      <Stack.Screen
        name={routes.onboarding}
        component={OnboardingController}
        options={{ title: "VOXCRAFT | Get Started" }}
      />

      <Stack.Screen
        name={routes.notfound}
        component={NoFoundController}
        options={{ title: "VOXCRAFT | No Found" }}
      />
    </Stack.Navigator>
  );
}

const styles = StyleSheet.create({
  container: {},
});

export default AuthNavigator;
